import { createBasicSelector } from 'util/redux'
import { selectBooleanPreferenceByName } from './selectBooleanPreferenceByName'

export const selectCurrentUserPrefersAutoadvanceToNextTicket = createBasicSelector(
  state => selectBooleanPreferenceByName(state, 'autoadvance_to_next_ticket')
)
